// ** React Imports
import { useState } from 'react'

// ** Reactstrap Imports
import { Accordion, AccordionBody, AccordionHeader, AccordionItem } from 'reactstrap'

const AccordionForm = ({Form,title,toggle,isEdit=false}) => {
  // ** State
  const [open, setOpen] = useState(()=> {
    return isEdit===true ? title : ''
  })

  const toggleFun = id => {
    toggle && (open === id ? setOpen() : setOpen(id))
  }
  return (
    <Accordion className='accordion-border' open={open} toggle={toggleFun} >
      <AccordionItem>
        <AccordionHeader targetId={title}>{title}</AccordionHeader>
        <AccordionBody accordionId={title}>
          {Form}
        </AccordionBody>
      </AccordionItem>
    </Accordion>
  )
}
export default AccordionForm
